import React from "react";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import Button from "@mui/material/Button";
import { getDownloadFilename } from "../../../../config/fileTypeConfig";

const PrescriptionTabItem = ({ title, note, linkedFile, date, text }) => {
  const handleDownload = async () => {
    fetch(linkedFile)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = getDownloadFilename(linkedFile, title);
        document.body.appendChild(a);
        a.click();
        a.remove();
      });
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  return (
    <div 
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "16px 20px",
        backgroundColor: "#FFFFFF",
        border: "1px solid #E5E7EB",
        borderRadius: "8px",
        marginBottom: "8px",
        fontFamily: "Inter"
      }}
    >
      {/* Title Column */}
      <div style={{ flex: 1 }}>
        <h6 
          style={{
            color: "#1F2937",
            fontSize: "14px",
            fontWeight: 500,
            margin: 0,
            marginBottom: "4px",
            fontFamily: "Inter"
          }}
        >
          {title}
        </h6>
        {text && (
          <p 
            style={{
              color: "#6B7280",
              fontSize: "12px",
              fontWeight: 400,
              margin: 0,
              fontFamily: "Inter",
              textTransform: "capitalize"
            }}
          >
            {text}
          </p>
        )}
      </div>
      
      {/* Category Column */}
      <div 
        style={{
          color: "#6B7280",
          fontSize: "13px",
          fontWeight: 400,
          fontFamily: "Inter",
          minWidth: "120px",
          textAlign: "center",
          textTransform: "capitalize"
        }}
      >
        {note}
      </div>

      {/* Date Column */}
      <div 
        style={{
          color: "#6B7280",
          fontSize: "13px",
          fontWeight: 400,
          fontFamily: "Inter",
          minWidth: "100px",
          textAlign: "center"
        }}
      >
        {formatDate(date)}
      </div>

      {/* Actions Column */}
      <div style={{ minWidth: "80px", textAlign: "right" }}>
        <Button 
          component="a"
          href={linkedFile}
          target="_blank"
          download
          size="small"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            textTransform: 'none',
            color: '#414141',
            backgroundColor: '#fafafa',
            padding: '6px 12px',
            borderRadius: '50px',
            fontSize: '13px',
            fontWeight: 500,
            margin: 0,
            minWidth: 'auto',
            fontFamily: "Inter",
            textDecoration: "none"
          }}
        >
          <VisibilityOutlinedIcon fontSize="small" />
          <span>View</span>
        </Button>
      </div>
    </div>
  );
};

export default PrescriptionTabItem;
